import React from "react";
import { useNavigate } from "react-router-dom";

// Client and Device are two symmetric entry points onto the same session data.
export function SessionsModeToggle({ active }) {
  const navigate = useNavigate();
  return (
    <div className="inline-flex items-center bg-slate-100 border border-slate-200 rounded-full p-1 gap-1">
      {[
        { key: "client", label: "Client", to: "/sessions/clients" },
        { key: "device", label: "Device", to: "/sessions/devices" },
      ].map((opt) => (
        <button
          key={opt.key}
          onClick={() => navigate(opt.to)}
          className={`text-xs font-semibold px-3.5 py-1.5 rounded-full transition-colors ${
            active === opt.key
              ? "bg-[#08148C] text-white"
              : "text-slate-500 hover:text-slate-800"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
